// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__ZBJai","svg":"styles_svg__CbJyf"};